<navigation-dropdown [isNavigationDropdownButtonClassNeeded]="!withoutBorderOnFocus" [menuItems]="profileMenuItems" [dropdownTitle]="'profile' | localize" dropdownMenuClass="ml-8px">
  <ui-avatar [uiPicture]="profile.picture" gh-dropdown-toggle uiSize="sm" uiAlt="Profile picture" data-test-id="user-avatar-in-left-navigation"></ui-avatar>
</navigation-dropdown>
